import ExchangeRateForm from './ExchangeRateForm.component';

export default ExchangeRateForm;
